import React, { useState, useEffect } from "react";
import REMALogo from "../../assets/REMA/logo.svg";
import { EVENT_DATE, NAV_HEIGHT, REMA_LANDING_PAGE_URL } from "./constants";
import EventCountdownTimer from "./EventCountdownTimer";
import { Link } from "react-router-dom";

const FormPageNavbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [timeLeft, setTimeLeft] = useState({
    days: 30,
    hours: 20,
    minutes: 14,
    seconds: 9,
  });

  // Set the target date for the conference (you can modify this date)
  const targetDate = new Date(EVENT_DATE).getTime();

  useEffect(() => {
    const timer = setInterval(() => {
      const now = new Date().getTime();
      const difference = targetDate - now;

      if (difference > 0) {
        const days = Math.floor(difference / (1000 * 60 * 60 * 24));
        const hours = Math.floor(
          (difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        const minutes = Math.floor(
          (difference % (1000 * 60 * 60)) / (1000 * 60)
        );
        const seconds = Math.floor((difference % (1000 * 60)) / 1000);

        setTimeLeft({ days, hours, minutes, seconds });
      } else {
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [targetDate]);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav className=" text-white fixed top-0 z-50  font-sora w-full  bg-[#11302D] flex items-center">
      <div className="container mx-auto  " style={{ height: NAV_HEIGHT }}>
        <div className="flex items-center justify-between h-full px-4">
          {/* Logo Section */}
          <div className="flex items-center">
            <Link to={REMA_LANDING_PAGE_URL} className="flex-shrink-0">
              <img
                src={REMALogo}
                alt="REMA Conference"
                className="h-full w-auto"
              />
            </Link>
          </div>

          {/* Countdown Timer - Hidden on mobile, visible on larger screens */}
          <div className="hidden md:flex items-center">
            <div className="flex space-x-5 items-center">
              {[
                { value: timeLeft.days, label: "Days" },
                { value: timeLeft.hours, label: "Hours" },
                { value: timeLeft.minutes, label: "Minutes" },
                { value: timeLeft.seconds, label: "Seconds" },
              ].map(({ value, label }, index, arr) => (
                <>
                  <div key={label} className="flex flex-col w-16 text-center ">
                    <div className="text-xl font-semibold leading-none">
                      {value.toString().padStart(2, "0")}
                    </div>
                    <div className="text-xs text-[#CBF07F] mt-1">{label}</div>
                  </div>
                  {index < arr.length - 1 && (
                    <div className="h-12 w-[1px] bg-white/20 block" />
                  )}
                </>
              ))}
            </div>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={toggleMenu}
              className="text-white hover:text-green-200 focus:outline-none focus:text-green-200 p-2"
            >
              <svg
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                {isMenuOpen ? (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                ) : (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                )}
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="lg:hidden bg-green-700 p-4  w-fill">
            {/* Mobile Countdown Timer */}
            <EventCountdownTimer />
          </div>
        )}
      </div>
    </nav>
  );
};

export default FormPageNavbar;
